<!-- 缺省图组件 -->
<template>
  <div class="rt-defaultImage">
    <div :class="classes" class="image-content">
      <slot>
        <rt-icon :size="iconSize" name="rt-base-default_image" />
      </slot>
    </div>
    <div class="describe">
      <slot name="describe">
        啊哦！暂时搜索不到您要的内容哦！
      </slot>
    </div>
  </div>
</template>

<script>
import rtIcon from '../icon/rtIcon';
export default {
  name: 'RtDefaultImage',
  components: {
    rtIcon
  },
  props: {
    size: {
      type: String,
      default: 'small'
    }
  },
  computed: {
    classes() {
      return `${this.size}`;
    },
    iconSize() {
      let size = this.size;
      let iconSize = '';
      switch (size) {
        case 'small':
          iconSize = 320;
          break;
        case 'medium':
          iconSize = 400;
          break;
        case 'large':
          iconSize = 480;
          break;
        default:
          iconSize = 320;
      }
      return iconSize;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtDefaultImage.vue?8da0cfb2